module.exports = __webpack_public_path__ + "static/media/comment-dots-solid.d5689b22.svg";